import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import ScheduleOutlinedIcon from '@mui/icons-material/ScheduleOutlined';
import FormatQuoteOutlinedIcon from '@mui/icons-material/FormatQuoteOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import SourceOutlinedIcon from '@mui/icons-material/SourceOutlined';

export const CHAR_LIMIT = 2000;
export const RESEARCH_DRAWER_MAX_HEIGHT = 280;
export const TARGET_RESEARCH_WORD_COUNT = 2000;

export const RESEARCH_SECTIONS = [
  { id: 'company', title: 'Company overview', sourceCount: 5, icon: BusinessOutlinedIcon },
  { id: 'decision', title: 'Decision makers', sourceCount: 3, icon: GroupsOutlinedIcon },
  { id: 'why-now', title: 'Why now?', sourceCount: 6, icon: ScheduleOutlinedIcon },
  { id: 'quotes', title: 'Relevant quotes', sourceCount: 4, icon: FormatQuoteOutlinedIcon },
  { id: 'business', title: 'Business model & revenue streams', sourceCount: 4, icon: AccountTreeOutlinedIcon },
  { id: 'customers', title: 'Similar customers', sourceCount: 3, icon: HandshakeOutlinedIcon },
  { id: 'sources', title: 'All sources', sourceCount: 21, icon: SourceOutlinedIcon },
];

export const REFINE_CHIPS = [
  'Make it shorter',
  'Less salesy',
  'More specific to Nike',
  'Add social proof',
  'Softer ask',
];

export const INITIAL_CONTACT_FORM = {
  fullName: '',
  company: '',
  title: '',
  linkedin: '',
  howDoYouKnowThisPerson: '',
  whyClientRelevant: '',
  anythingElse: '',
};

export const textFieldSx = {
  mb: 1.5,
  '& .MuiOutlinedInput-root': {
    bgcolor: '#fff',
    borderRadius: 1.5,
  },
};
